import _ from "lodash";
import React from "react";
import classes from "./DropDown.scss";
import I18nHOC from "UIComponents/I18nHOC";
import { Dropdown, DropdownMenu, IconButton } from "@toddle-edu/ds-web";
import { DotsVerticalOutlined } from "@toddle-edu/ds-icons";

const DropDown = ({
  onClickDelete,
  onClickEdit,
  onUpdateShowDropDown,
  t,
  isOwnChat,
  togglePinMessage,
  type,
  showFlatMessage = false,
}) => {
  const menuItems = [
    {
      key: "EDIT",
      label: t("common:edit"),
      shouldShow: isOwnChat,
    },
    {
      key: "UN_PIN",
      label: t("classRoom:un_pin"),
      shouldShow: _.isEqual(type, "REMARK") && isOwnChat,
    },
    {
      key: "DELETE",
      label: t("common:delete"),
      shouldShow: true,
    },
  ];
  const onOptionClick = item => {
    switch (item.key) {
      case "EDIT":
        onClickEdit();
        break;
      case "UN_PIN":
        togglePinMessage();
        break;
      case "DELETE":
        onClickDelete();
        break;
    }
  };

  return (
    <div className={classes.container}>
      <Dropdown
        overlay={
          <DropdownMenu
            options={_.filter(menuItems, item => item.shouldShow)}
            onClick={onOptionClick}
          />
        }
        onVisibleChange={value => onUpdateShowDropDown(value)}
      >
        <IconButton
          className="relative"
          variant={"plain"}
          size={showFlatMessage ? "x-small" : "medium"}
          icon={<DotsVerticalOutlined />}
        />
      </Dropdown>
    </div>
  );
};

export default I18nHOC({ resource: "common" })(DropDown);
